export default [
    {
        path: '/about',
        name: 'about',
        component: () => import('VIEWS/About.vue')
    }
]
